// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"dec393f0","749":"ef9953f2","903":"83daff65"}[chunkId] + ".chunk.js";
};